import { GeoObject } from './GeoObject.js';

export class GeoObjectTbm extends GeoObject {

    constructor(modelSection, data = {}) {

        super(modelSection, data);

        this.axisElevation = data.axisElevation ?? null;
        this.excavationDiameter = data.excavationDiameter ?? null;
        this.slope = data.slope ?? null;
        this.coordinateXStart = data.coordinateXStart ?? null;
        this.tunnelOrientationType = data.tunnelOrientationType ?? null;
        this.boundaries = data.boundaries ?? [];
        this.sensors = data.sensors ?? [];

    }

}
